var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_3016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2216 19.3487L8.45743 15.1128L11.5222 18.1765L16.4741 13.2257L18.4165 15.167V9.75033H12.9998L14.9423 11.6927L11.5222 15.1128L8.45851 12.0481L3.10035 17.4062C2.48277 16.0196 2.16457 14.5183 2.16651 13.0003C2.16651 7.01708 7.0166 2.16699 12.9998 2.16699C18.9831 2.16699 23.8332 7.01708 23.8332 13.0003C23.8332 18.9836 18.9831 23.8337 12.9998 23.8337C11.286 23.8348 9.59643 23.4287 8.07025 22.649C6.54408 21.8692 5.22498 20.7381 4.2216 19.3487Z",
    fill: "url(#paint0_linear_901_3016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_3016",
    x1: 13.9733,
    y1: 2.16699,
    x2: 13.9733,
    y2: 35.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE1E14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_3016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunds);
export default __webpack_public_path__ + "static/media/funds.67e64cc83c2991de03a4d8e3f0815d0d.svg";
export { ForwardRef as ReactComponent };